import React from "react";
import {useDraggable} from "@dnd-kit/core";
import {COLUMN_CONFIGS, getAlignmentClass, SelectableComp} from "./configurableCompsSelectTypes.tsx";
import {SELECTABLE_TYPE} from "./CompsDragDropTable.tsx";
import {isCompTypeActive} from "../../dyanimcFormUtil.tsx";

const DraggableCompRowRenderer: React.FC<{
    selectableComp: SelectableComp;
    onCompClick?: (comp: SelectableComp) => void;
    disabled: boolean
}> = ({ selectableComp, onCompClick, disabled }) => {
    const {
        attributes,
        listeners,
        setNodeRef,
        isDragging
    } = useDraggable({
        id: `${SELECTABLE_TYPE}-${selectableComp.propertyValuation?.address}-${selectableComp.propertyValuation?.mlsId}`,
        data: { type: SELECTABLE_TYPE, SELECTABLE_TYPE: selectableComp }
    });

    const style = {
        opacity: isDragging ? 0.5 : 1,
        cursor: isDragging ? 'grabbing' : 'grab'
    };

    return (
        <tr
            ref={setNodeRef}
            style={!disabled ? style : {}}
            {... !disabled ? attributes : {}}
            {...!disabled ? listeners : {}}
            className={`${disabled ? `${isCompTypeActive(selectableComp.propertyValuation?.compType) ? "bg-green-50" : "bg-blue-50"}` : "hover:bg-gray-50"} transition-colors`}
            onClick={(event) => {
                event.stopPropagation();
                if (onCompClick) {
                    onCompClick(selectableComp);
                }
            }}
        >
            {/* Generate cells based on column configuration */}
            {/* This ensures each cell corresponds to its header */}
            {COLUMN_CONFIGS.map((column) => (
                <td
                    key={column.key}
                    className={`px-2 sm:px-3 lg:px-4 py-1.5 sm:py-2 ${getAlignmentClass(column.align)} ${column.minWidth || ''} ${column.className || ''}`}
                >
                    {/* Render cell content using the column's render function */}
                    {column.render(selectableComp.propertyValuation, disabled)}
                </td>
            ))}
        </tr>
    );
}

export const DraggableCompRow = React.memo(DraggableCompRowRenderer);